import request from '../../lib/api/request';

export function getCountries() {
  return request({ method: 'GET', url: 'config/countries' });
}
